import { useState, useEffect } from "react";
import { useBranding, Brands } from "providers";
import "./ProgressSpinner.css";

interface LoaderWithMessageProps {
  message?: string | string[];
}

export const LoaderWithMessage = ({ message }: LoaderWithMessageProps) => {
  const { brand } = useBranding();
  const [currentMessage, setCurrentMessage] = useState<string>("");
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (Array.isArray(message)) {
      setCurrentMessage(message[0]);
      setMessageIndex(0);

      const interval = setInterval(() => {
        setMessageIndex((prevIndex) => {
          const nextIndex = (prevIndex + 1) % message.length;
          setCurrentMessage(message[nextIndex]);
          return nextIndex;
        });
      }, 10000); // 10 seconds per message

      return () => clearInterval(interval);
    } else if (message) {
      setCurrentMessage(message);
    }
  }, [message]);

  return (
    <div className="loader-overlay">
      <div className="progress-spinner-container">
        <svg className="progress-spinner" viewBox="0 0 100 100">
          {/* Background gray circle */}
          <circle
            cx="50"
            cy="50"
            r="40"
            fill="none"
            stroke="#E0E0E0"
            strokeWidth="8"
          />
          {/* Animated blue arc */}
          <circle
            cx="50"
            cy="50"
            r="40"
            fill="none"
            stroke="#0078D4"
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray="251.2"
            strokeDashoffset="188.4"
            className="progress-arc"
          />
        </svg>
        {currentMessage && (
          <div 
            className={`progress-message ${brand === Brands.AVMED ? 'avmed-brand' : 'default-brand'}`}
            role="status" 
            aria-live="polite"
          >
            {currentMessage}
          </div>
        )}
      </div>
    </div>
  );
};
